import { localizedStorefrontTarget } from './sc-locale-url.js';
import { navigationTarget } from './sc-filter-url.js';

// Keep preview/QA and acquisition context without carrying a collection view into a product.
function updateLink(link) {
  const href = link.getAttribute('href');
  if (!href || href.startsWith('#') || !/^https?:|^\//.test(href)) return;
  const target = link.hasAttribute('hreflang') || link.closest('localization-form, .localization-form')
    ? href : localizedStorefrontTarget(href, window.location.href).href;
  const next = navigationTarget(target, window.location.href);
  if (next.origin === window.location.origin && next.href !== link.href) link.href = next.href;
}
function updateLinks(root) {
  if (root instanceof Element && root.matches('a[href]')) updateLink(root);
  root.querySelectorAll?.('a[href]').forEach(updateLink);
}
updateLinks(document);
new MutationObserver((records) => {
  for (const record of records) for (const node of record.addedNodes) updateLinks(node);
}).observe(document.body, { childList: true, subtree: true });
window.addEventListener('popstate', () => updateLinks(document));
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('a[href]');
  if (link) updateLink(link);
}, { capture: true });
